import { get, set } from "lodash";
import { createPcbLayoutNodeExpressionContext, mechanicalExpressionScopeGlobals, } from "./expression_context";
import { getMechanicalExpressionDependencies } from "./expressionDependencyExtractor";
import { isExpression, stringifyMechanicalString } from "./ExpressionEvaluationHelpers";
/**
 * Evaluates a PCB layout rule expression for a specific node using direct utility approach.
 *
 * This function replaces the previous Redux selector-based rule evaluation with a more
 * direct and modular approach. It creates dynamic expression contexts by extracting
 * dependencies and generating atomic contexts from global and local scopes.
 *
 * @param document - Document data subset containing layout information
 * @param allNodes - Map of all PCB layout nodes
 * @param node - The specific node to evaluate the rule for
 * @param layoutNode - The parent layout node
 * @param ruleValue - The rule value to evaluate (can be expression or literal)
 * @param clipperShapeFactory - Factory for creating clipper shapes for geometric calculations
 * @param logger - Logger instance for debugging
 * @returns Evaluated rule value as string, or undefined for non-expressions
 */
export function getEvaluatedRuleValueForNode(document, allNodes, node, layoutNode, ruleValue, logger) {
    if (typeof ruleValue === "string" && isExpression(ruleValue)) {
        const deps = getMechanicalExpressionDependencies(ruleValue);
        const context = createPcbLayoutNodeExpressionContext({
            ...document,
            pcbLayoutNodes: allNodes,
        }, logger, node, layoutNode);
        const globals = mechanicalExpressionScopeGlobals(context).globals;
        const atomicContext = {};
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        deps?.forEach((dep) => {
            set(atomicContext, dep, get(context, dep) || get(globals, dep));
        });
        const evaluatedValue = stringifyMechanicalString(ruleValue, atomicContext);
        return evaluatedValue;
    }
}
//# sourceMappingURL=getEvaluatedRuleValue.js.map